import { useEffect, useState } from 'react';
import { Dialog } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import { useTermsOfServicesAcceptationStatus } from '~/hooks/useTermsOfServicesAcceptationStatus';
import { NewTermsOfServicesForm } from '../forms/NewTermsOfServicesForm';

const styles = stylex.create({
  dialog: {
    maxWidth: 1200,
    minWidth: 400,
    width: '80%',
  },
});

export type INewTermsOfServicesCheckerProps = Record<string, never>;

export const NewTermsOfServicesChecker: React.FC<
  INewTermsOfServicesCheckerProps
> = (props) => {
  const { sx } = props;

  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation();
  const tosAcceptationStatus = useTermsOfServicesAcceptationStatus();

  useEffect(() => {
    if (tosAcceptationStatus === 'required') {
      setShowModal(true);
    } else if (tosAcceptationStatus === 'accepted') {
      setShowModal(false);
    }
  }, [tosAcceptationStatus]);

  return (
    <Dialog
      actions={[]}
      sx={[styles.dialog, sx]}
      headline={t('NewTermsOfServicesChecker.title')}
      opened={showModal}
    >
      {t('NewTermsOfServicesChecker.new-terms-of-services-available')}
      <NewTermsOfServicesForm
        onSuccess={() => {
          window.location.reload();
        }}
      />
    </Dialog>
  );
};
